import React, { SyntheticEvent } from 'react'

import {
  AlignItems,
  Badge,
  Box,
  Button,
  Color,
  Display,
  withCitrusTheme,
  Text,
  FontWeight,
  JustifyContent,
  Spinner,
} from '@gousto-internal/citrus-react'

const CustomButton = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

const PriceBadge = withCitrusTheme(Badge, (theme) => ({
  backgroundColor: theme.color(Color.Secondary_600),
  color: theme.color(Color.White),
  padding: theme.spacing(2),
  minWidth: theme.spacing(14),
  minHeight: theme.spacing(8),
  display: Display.Flex,
  justifyContent: JustifyContent.Center,
}))

type SidesButtonProps = {
  disabled?: boolean
  onClick: (e: SyntheticEvent) => void
  totalPrice: number
}

export const SidesButton = ({ disabled, onClick, totalPrice }: SidesButtonProps) => (
  <CustomButton data-testid="continue-sides" disabled={disabled} height="50px" onClick={onClick}>
    <Box alignItems={AlignItems.Center} display={Display.Flex}>
      <Box paddingRight={2}>
        {totalPrice > 0 ? 'Continue with sides' : 'Continue without sides'}
      </Box>
      {disabled && <Spinner color={Color.White} size={3} />}
      {!disabled && totalPrice > 0 && (
        <PriceBadge>
          <Text fontWeight={FontWeight.Bold} size={0} display={Display.Flex}>
            £{totalPrice.toFixed(2)}
          </Text>
        </PriceBadge>
      )}
    </Box>
  </CustomButton>
)
